import { enhanceUri } from 'nallian-shared-ui/lib/lib/url';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';

const v1Api = enhanceUri('v1', appsettings.organisationApiBaseUrl);
const v2Api = enhanceUri('v2', appsettings.organisationApiBaseUrl);
const v3Api = enhanceUri('v3', appsettings.organisationApiBaseUrl);

export default {
  communityTemplate: host => `${v1Api}/registrations/templates/hosts?url=${host}`,
  communityText: (tag, lang) => `${v1Api}/communities/${tag}/texts/welcome/${lang}`,
  legalDocuments: id => `${v1Api}/legal-documents${id ? `/${id}` : ''}`,
  legalDocumentsDownload: id => `${v1Api}/legal-documents/${id}/download`,
  organisations: () => `${v1Api}/organisations`,
  organisation: id => `${v1Api}/organisations/${id}`,
  getLanguages: () => `${v1Api}/languages`,
  getTimezones: () => `${v2Api}/timezones`,
  postRenewUserActivation: oldToken => `${v1Api}/users/activations/renew/${oldToken}`,
  organisationLogo: organisationId => `${v1Api}/organisations/${organisationId}/logo`,
  authorizationRoles: organisationId =>
    `${v1Api}/organisations/${organisationId}/authorizationroles`,
  authorizationRole: ({ organisationId, authorizationRoleId }) =>
    `${v1Api}/organisations/${organisationId}/authorizationroles/${authorizationRoleId}`,
  organisationRegistrations: organisationId =>
    `${v1Api}/organisations/${organisationId}/registrations`,
  registrationsJoinRequest: id => `${v1Api}/registrations/${id}/payload/join-organisation-request`,
  communityMembers: communityId => `${v1Api}/communities/${communityId}/members`,
  getCommunityMembers: communityId => `${v2Api}/communities/${communityId}/members`,
  createCommunityMember: () => `${v1Api}/communityMembers`,
  legalDocument: id => `${v1Api}/legal-documents/${id}`,
  communityHost: () => `${v2Api}/communities/hosts`,
  organisationIdentificationCodes: id => `${v1Api}/organisations/${id}/identificationcodes`,
  organisationAddress: id => `${v2Api}/organisations/${id}/addresses`,
  reinvitePrincipal: id => `${v2Api}/principals/${id}/reinvite`,
  activatePrincipal: id => `${v1Api}/principals/${id}/activate`,
  getOrganisationsByName: name => `${v1Api}/organisations?organisationName=${name}`,
  timezones: () => `${v2Api}/timezones`,
  communityJoinRequests: tag => `${v2Api}/communities/${tag}/join-requests`,
  principals: id => `${v2Api}/principals${id ? `/${id}` : ''}`,
  availableRoles: id => `${v2Api}/organisations/${id}/communities/apps/roles`,
  communityMembersV2: (id, organisationId) =>
    `${v2Api}/communities/${id}/members${organisationId ? `/${organisationId}` : ''}`,
  invitation: token => `${v2Api}/invitations/${token}`,
  completeInvitation: token => `${v2Api}/invitations/${token}/complete`,
  communityLegalDocuments: tag => `${v2Api}/communities/${tag}/legal-documents`,

  ///
  getUserByName: () => `${v1Api}/users`,
  getOrganisations: id => `${v1Api}/organisations${id ? `/${id}` : ''}`,
  deleteOrganisation: id => `${v1Api}/organisations/${id}`,
  getOrganisation: id => `${v1Api}/organisations/${id}`,
  updateOrganisation: id => `${v1Api}/organisations/${id}`,
  getCommunities: () => `${v1Api}/communities`,
  getCommunity: id => `${v1Api}/communities${id ? `/${id}` : ''}`,
  postOrganisation: () => `${v2Api}/organisations`,
  createUser: () => `${v1Api}/users`,
  communityRoles: id => `${v1Api}/communities/${id}/roles`,
  communityRole: ({ communityId, communityRoleId }) =>
    `${v1Api}/communities/${communityId}/roles/${communityRoleId}`,
  communityRoleMembers: ({ communityId, roleId }) =>
    `${v1Api}/communities/${communityId}/roles/${roleId}/members`,
  communityMember: (communityId, organisationId) =>
    `${v1Api}/communities/${communityId}/members/${organisationId}`,
  communityMemberv2: (communityId, organisationId) =>
    `${v2Api}/communities/${communityId}/members/${organisationId}`,
  tenants: () => `${v1Api}/tenants`,
  tenant: id => `${v1Api}/tenants/${id}?include=properties`,
  tenantBlobs: id => `${v1Api}/tenants/${id}/blobs`,
  tenantBlob: ({ tenantId, tenantBlobId }) => `${v1Api}/tenants/${tenantId}/blobs/${tenantBlobId}`,
  getTenantId: () => `${v1Api}/tenants/tenantId`,

  tenantPropertyTypes: () => `${v1Api}/tenants/properties/types`,
  apiResources: () => `${v1Api}/apiresources`,
  apiResource: id => `${v1Api}/apiresources/${id}`,
  apiSecrets: resourceId => `${v1Api}/apiresources/${resourceId}/apisecrets`,
  apiSecret: (id, resourceId) => `${v1Api}/apiresources/${resourceId}/apisecrets/${id}`,
  apiScope: () => `${v1Api}/apiscopes`,
  getUsers: organisationId => `${v1Api}/organisations/${organisationId}/users`,
  getUserDetail: id => `${v1Api}/users/${id}`,
  resetPassword: id => `${v1Api}/users/${id}/password`,
  getUserActivation: token => `${v1Api}/users/activations/${token}`,
  activateUser: () => `${v1Api}/users/activations/`,
  updateUser: id => `${v1Api}/users/${id}`,
  deleteUser: id => `${v1Api}/users/${id}`,
  checkUsernameExists: () => `${v1Api}/users`,
  organisationApps: () => `${v2Api}/organisation-apps`,
  availableOrganisationAppSubscriptions: organisationId =>
    `${v2Api}/organisations/${organisationId}/community-apps`,
  appSubscriptions: (communityAppId, organisationId) =>
    `${v2Api}/community-apps/${communityAppId}/organisations${
      organisationId ? `/${organisationId}` : ''
    }`,
  appSubscription: id => `${v1Api}/appsubscriptions/${id}`,
  appSubscriptionStates: () => `${v1Api}/apps/activationstates`,
  organisationCommunities: organisationId => `${v1Api}/organisations/${organisationId}/communities`,
  reinviteUser: () => `${v1Api}/users/reinvite`,
  identificationCodes: id => `${v2Api}/identification-codes${id ? `/${id}` : ''}`,
  identificationCodeTypes: id => `${v2Api}/identification-code-types${id ? `/${id}` : ''}`,
  // V2
  principalIdentity: (principalId, identityId) =>
    `${v2Api}/principals/${principalId}/principal-identities${identityId ? `/${identityId}` : ''}`,
  organisationRoles: tag => `${v2Api}/organisations/roles${tag ? `/${tag}` : ``}`,
  community: tag => `${v1Api}/communities/${tag}`,
  communityRoles2: (id, orgRoleTag) =>
    `${v2Api}/community/${id}/organisations/roles${orgRoleTag ? `/${orgRoleTag}` : ``}`,
  communityMemberRoles: (id, organisationId) =>
    `${v2Api}/community/${id}/organisations/${organisationId}/roles`,
  communitySuites: id => `${v2Api}/communities/${id}/suites`,
  communitySuite: communitySuiteId =>
    `${v2Api}/communities/suites${communitySuiteId ? `/${communitySuiteId}` : ''}`,
  communityApps: id => `${v2Api}/community-apps${id ? `/${id}` : ``}`,
  apps: tag => `${v2Api}/apps${tag ? `/${tag}` : ''}`,
  appCommunities: appId => `${v2Api}/apps/${appId}/communities`,
  appOrganisations: appId => `${v2Api}/apps/${appId}/organisations`,
  suites: tag => `${v2Api}/suites${tag ? `/${tag}` : ''}`,
  appInstallations: tag => `${v2Api}/app-installations${tag ? `/${tag}` : ``}`,
  pendingInvitations: orgId => `${v2Api}/organisations/${orgId}/pending-invitations`,
  pendingInvitation: id => `${v2Api}/pending-invitations${id ? `/${id}` : ''}`,
  reInvite: id => `${v2Api}/pending-invitations/${id}/reinvite`,
  pendingInvitationStates: () => `${v2Api}/organisations/pendinginvitations/states`,
  pendingInvitationTypes: () => `${v2Api}/organisations/pendinginvitations/types`,
  appInstallationsDetail: (appId, installationId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}`,
  appInstallationOrganisations: (appId, installationId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/organisations`,
  roleAssignments: (appId, installationId, featureId, roleId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/feature/${featureId}/roles/${roleId}/assignments`,
  roleAppAssignments: (appId, installationId, featureId, roleId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/feature/${featureId}/roles/${roleId}/app-assignments`,
  roleDetail: (appId, installationId, featureId, roleId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/roles/${roleId}`,
  roleCommunities: (appId, installationId, featureId, roleId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/roles/${roleId}/communities`,
  roleOrganisations: (appId, installationId, featureId, roleId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/roles/${roleId}/organisations`,
  featureAssignments: (appId, installationId, featureId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/feature/${featureId}/assignments`,
  featureDetail: (appId, installationId, featureId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}`,
  featureSubscriptions: (appId, installationId, featureId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/subscriptions`,
  featureSubscriptionDetail: (appId, installationId, featureId, subscriptionId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/subscriptions/${subscriptionId}`,
  featureSubscriptionCommunities: (appId, installationId, featureId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/features/${featureId}/subscriptions/communities`,
  validationPatterns: () => `${v2Api}/validation-patterns`,
  relationTypes: id => `${v1Api}/relation-types${id ? `/${id}` : ''}`,
  relations: id => `${v1Api}/relations${id ? `/${id}` : ''}`,
  onboardingTemplates: id => `${v1Api}/onboarding-templates${id ? `/${id}` : ''}`,
  joinRequests: id => `${v2Api}/join-requests${id ? `/${id}` : ''}`,
  v3JoinRequests: id => `${v3Api}/join-requests${id ? `/${id}` : ''}`,
  v3JoinRequestsOverview: id => `${v3Api}/communities/${id}/join-requests`,
  denyJoinRequests: id => `${v2Api}/join-requests/${id}/deny`,
  markUniqueJoinRequest: id => `${v3Api}/join-requests/${id}/mark-unique`,
  userGroups: (organisationId, userGroupId) =>
    `${v1Api}/organisations/${organisationId}/user-groups${userGroupId ? `/${userGroupId}` : ''}`,
  userGroupsDetails: organisationId =>
    `${v1Api}/organisations/${organisationId}/user-groups/details`,
  userGroupMembers: (organisationId, userGroupId, memberId) =>
    `${v1Api}/organisations/${organisationId}/user-groups/${userGroupId}/members${
      memberId ? `/${memberId}` : ''
    }`,
  principalJoinRequests: (orgId, id) =>
    `${v2Api}/organisations/${orgId}/join-requests${id ? `/${id}` : ''}`,
  denyPrincipalJoinRequests: (orgId, id) =>
    `${v2Api}/organisations/${orgId}/join-requests/${id}/deny`,
  acceptPrincipalJoinRequests: (orgId, id) =>
    `${v2Api}/organisations/${orgId}/join-requests/${id}/accept`,
  applyOnboardingTemplate: (communityId, communityMemberId) =>
    `${v2Api}/communities/${communityId}/members/${communityMemberId}/apply-onboarding-template`,
  identities: () => `${v1Api}/identities`,
  identitiesOverview: () => `${v1Api}/identities-overview`,
  identityPrincipals: identityId => `${v1Api}/identities/${identityId}/principals`,
  anonymizeIdentity: identityId => `${v1Api}/identities/${identityId}/anonymize`,
  communities: id => `${v2Api}/communities${id ? `/${id}` : ''}`,
  notificationSettings: id => `${v2Api}/communities/${id}/notification-settings`,
  hosts: id => `${v2Api}/communities/${id}/hosts`,
  themeLookups: id => `${v1Api}/theme-lookups${id ? `/${id}` : ''}`,
  communityTexts: (tag, id) => `${v2Api}/communities/${tag}/texts${id ? `/${id}` : ''}`,
  communityWelcomeTexts: tag => `${v1Api}/communities/${tag}/texts/WELCOME`,
  createCommunityWelcomeText: (tag, language) => `${v1Api}/communities/${tag}/texts/${language}`,
  updateCommunityWelcomeText: (tag, textId, language) =>
    `${v1Api}/communities/${tag}/texts/${textId}/${language}`,
  communityAppClients: (communityAppId, id) =>
    `${v2Api}/community-apps/${communityAppId}/clients${id ? `/${id}` : ''}`,
  organisationAdmins: id => `${v1Api}/organisations/${id}/administrators`,
  text: (tag, type, lang) => `${v1Api}/communities/${tag}/texts/${type}/${lang}`,
  v2Organisations: () => `${v2Api}/organisations`,
  appInstallationCommunities: (appId, installationId) =>
    `${v2Api}/apps/${appId}/installations/${installationId}/communities`,
  communityIdentificationCodeTypes: (id, typeId) =>
    `${v1Api}/communities/${id}/identification-code-types${typeId ? `/${typeId}` : ''}`,
  organisationContacts: (organisationId, contactId) =>
    `${v1Api}/organisations/${organisationId}/contacts${contactId ? `/${contactId}` : ''}`,
  organisationLogoV2: organisationId => `${v2Api}/organisations/${organisationId}/logo`,
  version: () => `${v1Api}/supportability/version`,
  principalDocuments: principalId => `${v1Api}/principals/${principalId}/documents`,
  principalDocument: (principalId, documentId) =>
    `${v1Api}/principals/${principalId}/documents/${documentId}`,
  confirmDocument: principalId => `${v1Api}/principals/${principalId}/documents/confirmed`,
  documentPreviewUrl: (principalId, documentId) =>
    `${v1Api}/principals/${principalId}/documents/${documentId}/preview-url`,
  securedDocumentTypes: () => `${v1Api}/secured-documents/types`,
  analyzeDocument: () => `${v1Api}/secured-documents/analyze`,
  organisationPrincipalDocuments: orgId => `${v1Api}/organisations/${orgId}/principal-documents`,
  impersonationRequests: () => `${v1Api}/impersonation-requests`,
  impersonationRequest: id => `${v1Api}/impersonation-requests/${id}`,
  revokeImpersonation: id => `${v1Api}/impersonation-requests/${id}/revoke`,
  coApproveImpersonation: id => `${v1Api}/impersonation-requests/${id}/co-approve`,
  coDenyImpersonation: id => `${v1Api}/impersonation-requests/${id}/co-deny`,
  impersonationAllowedDurations: () => `${v1Api}/impersonation-requests/allowed-durations`,
  impersonationSession: () => `${v1Api}/impersonation-session`,
};
